"use client";

import React from "react";
export default function CoreTrainingAreas() {
  return null;
}